module.exports = __webpack_public_path__ + "img/sidebar.8bbedea0.jpg";